import { Fragment } from "react";

/**
 * A file's name that wraps at its folders first: a break is allowed after each "/" (`<wbr>`), as
 * the browser allows one after "-" already. Its box gives `break-words` for a part too long for a
 * line, so a word breaks only when it must (never `break-all`).
 */
export function FileName({ name }: { name: string }) {
  const parts = name.split("/");
  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <>
              /<wbr />
            </>
          )}
        </Fragment>
      ))}
    </>
  );
}
